module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-coordinate",
      "title": "Acquisizione Coordinate"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c9b6280a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Coordinate.vue
// module id = 909
// module chunks = 39